import { Button, ConfigProvider, DatePicker, Form, Select, message } from "antd";
import "antd/dist/antd.css";
import i18n from "i18next";
import moment from "moment";
import "moment/locale/fr";
import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Link, Redirect, useHistory } from "react-router-dom";
import { bindActionCreators } from "redux";
import Loading from "../../components/loading";
import guestImg from "../../image/guest.png";
import { requestApiGuest, requestApiValidateBySponsor, requestApiValidateSponsor } from "../../store/actions/actions";
import styles from "./endAccountBySponsor.module.css";

const { Option } = Select;

const today = `${moment()._d.getDate()}/${moment()._d.getMonth() + 1}/${moment()._d.getFullYear()}`;

const EndAccountBySponsor = (props) => {
  const [loading, setLoading] = useState(true);
  const [finish, setFinish] = useState(false);
  const [id_guest, setId_guest] = useState("");
  const [start_date, setStart_date] = useState(today);
  const [duration, setDuration] = useState("1");
  const [request_success, setRequest_success] = useState(false);
  const history = useHistory();

  const [form] = Form.useForm();

  const defaultValues = {
    remember: true,
    startAt: moment(start_date, "DD/MM/YYYY"),
    duration: duration.toString(),
  };

  const {
    data: { guest },
    t,
  } = props;

  const [locale, setLocale] = useState();
  const [language, setLanguage] = useState();

  useEffect(() => {
    setLanguage(i18n.language);
    if (language === "fr") {
      const data = require("antd/lib/locale/fr_FR");
      setLocale(data.default);
    } else {
      setLocale("en");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language, language]);

  useEffect(() => {
    document.title = `${props.t("endSponsor.header")} - Wifi Guest`;
    setId_guest(props.match.params.id);
    sessionStorage.setItem("redirect", props.match.params.id);
    if (!sessionStorage.getItem("access_token")) {
      sessionStorage.setItem("redirection", `${props.location.pathname}${props.location.search}`);
      history.push("/sso-connect");
    } else {
      props.requestApiGuest({
        id: props.match.params.id,
      });
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (props.data.guest) {
      compareDate();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.data.guest]);

  useEffect(() => {
    form.setFieldsValue(defaultValues);
  }, [form, defaultValues]);

  const compareDate = () => {
    let guest = props.data.guest;
    let date1 = new Date(moment(today, "DD/MM/YYYY").format("MM/DD/YYYY"));
    let date2 = new Date(moment(guest.startAt).format("MM/DD/YYYY"));
    // différence des heures
    let time_diff = date2.getTime() - date1.getTime();
    // différence de jours
    let days_Diff = time_diff / 1000;
    if (days_Diff > 0) {
      const day = moment(guest.startAt);
      setStart_date(`${day._d.getDate()}/${day._d.getMonth() + 1}/${day._d.getFullYear()}`);
    }
    setDuration(guest.validity_period / 86400);
  };

  const callbackConfirmBySponsor = (res) => {
    if (res) {
      message.success(<span style={{ marginLeft: "5px" }}>{props.t("endSponsor.server.success")}</span>);
      setRequest_success(true);
      setFinish(true);
    } else {
      message.error(<span style={{ marginLeft: "5px" }}>{props.t("endSponsor.server.error")}</span>);
    }
  };

  const callbackFinishConfirm = () => {
    if (request_success) {
      setFinish(true);
    }
  };

  const confirmBySponsor = (values) => {
    props.requestApiValidateSponsor({
      id: id_guest,
      body: {
        startAt: moment(values.startAt, "DD/MM/YYYY").format("YYYY-MM-DD"),
        validity_period: (values.duration * 86400).toString(),
      },
      callback: (e) => {
        callbackConfirmBySponsor(e);
        props.requestApiValidateBySponsor({
          id: id_guest,
          callback: () => {
            callbackFinishConfirm();
          },
        });
      },
    });
  };

  if (guest) {
    if (guest.validatedBySponsor) {
      message.warn(<span style={{ marginLeft: "5px" }}>{t("endSponsor.server.validated")}</span>);
      sessionStorage.removeItem("redirection");
      return <Redirect to={{ pathname: "/home-sso" }} />;
    }
  }

  if (finish) {
    sessionStorage.removeItem("redirection");
    return <Redirect to={{ pathname: "/account-success" }} />;
  }
  if (loading) {
    return (
      <div>
        <Loading />
      </div>
    );
  }

  return (
    <div className={styles.form_container}>
      <h3>{t("endSponsor.title")}</h3>
      <ConfigProvider locale={locale}>
        <Form name="basic" initialValues={defaultValues} onFinish={confirmBySponsor} autoComplete="off" layout="vertical" className={styles.form} form={form}>
          <div className={styles.guest__container}>
            <h5 className={styles.guest__title}>Invité</h5>
            <div className={styles.guest__info}>
              <div className={styles.guest__info__img}>
                <img src={guestImg} alt="icone homme costard sur fond orange" />
              </div>

              <p>
                <span className={styles.guest__info__label}>{t("endGuest.label.firstname")} :</span> {guest ? guest.firstName : "none"}{" "}
              </p>
              <p>
                <span className={styles.guest__info__label}>{t("endGuest.label.lastname")} :</span> {guest ? guest.lastName.toUpperCase() : ""}
              </p>
              <p>
                <span className={styles.guest__info__label}>{t("endGuest.label.mail")} :</span> {guest ? guest.guest : ""}
              </p>
              <p>
                <span className={styles.guest__info__label}>{t("endGuest.label.company")} :</span> {guest ? guest.company.toUpperCase() : ""}
              </p>
            </div>
            <div className={styles.guest__duration}>
              <p>{t("endSponsor.label.wish_date")} : </p>
              <p>
                <span className={styles.guest__info__label}>
                  {guest ? moment(guest.startAt).format("DD/MM/YYYY") : ""}- {t("endSponsor.label.duration")} : {guest ? duration : ""}
                  {t("endSponsor.select.day")}(s)
                </span>
              </p>
            </div>
          </div>

          <div className={styles.form_flex}>
            <Form.Item name="startAt" label={t("account_sso.label.startAt")} rules={[{ required: true }]} className={styles.input_date}>
              <DatePicker className={styles.input_date} placeholder={moment().format("DD/MM/YYYY")} locale={locale} format={t("date_format")} />
            </Form.Item>

            <Form.Item name="duration" label={t("account_sso.label.duration")} rules={[{ required: true }]} className={styles.input_duration}>
              <Select>
                <Option value="1">1 {t("account_sso.select.day")}</Option>
                <Option value="2">2 {t("account_sso.select.days")}</Option>
                <Option value="7">7 {t("account_sso.select.days")}</Option>
              </Select>
            </Form.Item>
          </div>
          <div className={styles.form_footer}>
            <div className={styles.form_footer_mandatory}>
              <p> {t("account_sso.label.mandatory")}</p>
            </div>
            <div className={styles.form_button}>
              <Form.Item>
                <Link to="/home-sso">
                  <Button danger size="large">
                    {t("account_sso.button.cancel")}
                  </Button>
                </Link>
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit" size="large">
                  {t("account_sso.button.continue")}
                </Button>
              </Form.Item>
            </div>
          </div>
        </Form>
      </ConfigProvider>
    </div>
  );
};

const mapStateToProps = (state) => ({ data: state.data });

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      requestApiGuest,
      requestApiValidateBySponsor,
      requestApiValidateSponsor,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(EndAccountBySponsor));
